module.exports = __webpack_public_path__ + "media/logos/Marmara 1-d4de239e.svg";